import styled from 'styled-components'
import { LoadingPlaceholder, Text } from '@sketch/components'
import { ReactComponent as Check } from '@sketch/icons/resolve-filled-17'

export const Paragraph = styled.p`
  margin: 0;
`

export const MembersTitleContainer = styled.div`
  display: flex;
`

export const WorkspaceMembershipsLoading = styled(LoadingPlaceholder)`
  margin-right: 8px;
`

export const IconWrapper = styled.div`
  width: 17px;
  height: 17px;
  margin: 4px 8px 4px 0px;
  line-height: 0;
  flex-shrink: 0;
  align-self: center;
`

export const InfoTextLine = styled(Text.Div).attrs({
  textStyle: 'copy.quaternary.standard.D',
})`
  display: flex;
  margin-left: 8px;
`

export const RestrictedPublicLinksWrapper = styled.div`
  /* Section contains a padding-bottom of 16px, so it will be 64px with this wrapper */
  padding-bottom: 48px;
  padding-top: 64px;
`

export const CheckIcon = styled(Check)`
  width: 17px;
  height: 17px;
  color: ${({ theme }) => theme.colors.state.positive.A};
  margin-top: 8px;
`

export const PublicDocumentLinksEnabledText = styled(Text.Div).attrs({
  textStyle: 'prominent.secondary.E',
})`
  margin-top: 7px; /* stylelint-disable-line scales/space */
  margin-left: 8px;
`
